import {
    Button,
    Card,
    Icon,
    Stack,
    TextField,
    TextStyle,
} from "@shopify/polaris";
import { CirclePlusMinor, DragDropMajorMonotone } from "@shopify/polaris-icons";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { ComponentLabelPolaris } from "../shared/ComponentLabelPolaris";
import AmazonIdeaAddCustomization from "./amazon-idea-add-customization";
import AmazonIdeaDropdownOption from "./amazon-idea-dropdown-option";
import { AmazonIdeaType, isFieldData, isFieldDropdown } from "./helper";
import { arrInvalid } from "../../helper";
import { DEFAULT_AMAZON_IDEA_KPI } from "./amazon-idea-form";

export default function AmazonIdeaFields({
    fields,
    setState,
    disabled,
    defaultOpen,
}) {
    const [open, setOpen] = useState(false);

    // useEffect(() => {
    //     if (!arrInvalid(fields)) return;
    //     setState((p) => {
    //         const kpi = calcuKpi(p.fields.length);
    //         return {
    //             ...p,
    //             fields: [...p.fields, createNewField()],
    //             kpi: String(Number(1) + kpi),
    //         };
    //     });
    // }, [JSON.stringify(fields)]);

    // useEffect(() => {
    //     if (!defaultOpen) return;
    //     setOpen(true);
    // }, [defaultOpen]);

    const handleClick = useCallback(
        (type) => {
            setState((p) => {
                const fields = [...p.fields, createNewField(type)];
                const kpi = calcuKpi(fields.length - 1);

                return {
                    ...p,
                    // fields: [...p.fields, createNewField(type)],
                    fields,
                    kpi: String(Number(1) + kpi),
                };
            });
        },
        [setState],
    );

    const handleFieldUpdate = useCallback(
        (index) => (value, id) => {
            setState((p) => {
                const fields = p.fields;
                const curIndex = fields.findIndex((_, idx) => idx === index);

                if (id === "type") {
                    fields[curIndex] = {
                        ...fields[curIndex],
                        ...createNewField(value),
                    };
                }

                fields[curIndex] = { ...fields[curIndex], [id]: value };
                return {
                    ...p,
                    fields,
                };
            });
        },
        [setState],
    );

    const handleRemove = useCallback(
        (index) => () => {
            setState((p) => {
                const fields = p.fields;
                const curIndex = fields.findIndex((_, idx) => idx === index);
                if (curIndex > -1) {
                    fields.splice(curIndex, 1);
                }

                let kpi = arrInvalid(fields) ? DEFAULT_AMAZON_IDEA_KPI : Number(1) + calcuKpi(fields.length - 1)
                kpi = String(kpi)
                kpi = Number(kpi).toFixed(2)

                return {
                    ...p,
                    fields,
                    kpi,
                };
            });
        },
        [setState],
    );

    const handleMoveField = useCallback(
        (dragIndex, hoverIndex) => {
            setState((p) => {
                const fields = p.fields;
                [fields[dragIndex], fields[hoverIndex]] = [
                    fields[hoverIndex],
                    fields[dragIndex],
                ];

                return {
                    ...p,
                    fields,
                };
            });
        },
        [setState],
    );

    const onClose = useCallback(() => {
        setOpen(false);
    }, []);

    const onOpen = useCallback(() => {
        setOpen(true);
    }, []);

    return (
        <Stack vertical>
            {fields?.length > 0 ? (
                <div style={{ marginLeft: 10 }}>
                    {/* <DndProvider backend={HTML5Backend}>
                        <Stack vertical>
                            {(fields || []).map((field, index) => (
                                <AmazonIdeaField
                                    key={`field_${index}`}
                                    field={field}
                                    index={index}
                                    handleFieldUpdate={handleFieldUpdate(index)}
                                    handleRemove={handleRemove(index)}
                                    onMoveField={handleMoveField}
                                />
                            ))}
                        </Stack>
                    </DndProvider> */}
                    {disabled ? (
                        <Stack vertical>
                            {(fields || []).map((field, index) => (
                                <AmazonIdeaCard
                                    key={`field_${index}`}
                                    field={field}
                                    handleRemove={handleRemove}
                                    index={index}
                                    disabled
                                >
                                    <AmazonIdeaFieldWrap
                                        field={field}
                                        handleFieldUpdate={handleFieldUpdate(
                                            index,
                                        )}
                                        onMoveField={handleMoveField}
                                        disabled
                                    />
                                </AmazonIdeaCard>
                            ))}
                        </Stack>
                    ) : (
                        <>
                            <DndProvider backend={HTML5Backend}>
                                <Stack vertical>
                                    {(fields || []).map((field, index) => (
                                        <AmazonIdeaField
                                            key={`field_${index}`}
                                            index={index}
                                            onMoveField={handleMoveField}
                                        >
                                            <AmazonIdeaCard
                                                field={field}
                                                index={index}
                                                handleRemove={handleRemove(
                                                    index,
                                                )}
                                            >
                                                <AmazonIdeaFieldWrap
                                                    field={field}
                                                    handleFieldUpdate={handleFieldUpdate(
                                                        index,
                                                    )}
                                                    onMoveField={
                                                        handleMoveField
                                                    }
                                                />
                                            </AmazonIdeaCard>
                                        </AmazonIdeaField>
                                    ))}
                                </Stack>
                            </DndProvider>
                        </>
                    )}
                </div>
            ) : null}
            {disabled ? null : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        icon={CirclePlusMinor}
                        onClick={onOpen}
                        children="Add Customization"
                    />
                </div>
            )}
            <AmazonIdeaAddCustomization
                open={open}
                onClose={onClose}
                onChange={handleClick}
            />
        </Stack>
    );
}

function AmazonIdeaCard({ index, field, handleRemove, children, disabled }) {
    return (
        <Card
            sectioned
            title={
                <Stack distribution="middle">
                    {disabled ? null : (
                        <span
                            style={{
                                display: "block",
                                // marginTop: 30,
                                cursor: "move",
                            }}
                        >
                            <Icon source={DragDropMajorMonotone} />
                        </span>
                    )}

                    <span>
                        <b>{`#${index + 1} `}</b>
                        {`${field.type}`}
                    </span>
                </Stack>
            }
            actions={
                disabled
                    ? undefined
                    : [
                          {
                              content: "Remove",
                              onAction: handleRemove,
                          },
                      ]
            }
        >
            {children}
        </Card>
    );
}

function AmazonIdeaField(props) {
    const { index, onMoveField, children } = props;
    const ref = useRef(null);

    const [, drop] = useDrop({
        accept: "amazonIdeaField",
        hover(item, monitor) {
            if (!ref.current) return;

            const dragIndex = item.index;
            const hoverIndex = index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect();

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            // Determine mouse position
            const clientOffset = monitor.getClientOffset();

            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            // Time to actually perform the action
            onMoveField(dragIndex, hoverIndex);

            item.index = hoverIndex;
        },
    });

    const [, drag] = useDrag({
        item: { type: "amazonIdeaField", index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    drag(drop(ref));

    return (
        <div ref={ref} style={{ cursor: "move" }}>
            {children}
        </div>
    );
}

function AmazonIdeaFieldWrap({ field, handleFieldUpdate, disabled }) {
    return (
        <Stack>
            <Stack.Item fill>
                <div style={{ cursor: "default" }}>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            alignItems: "start",
                            gap: "1.6rem",
                        }}
                    >
                        {/* <Select
                            id="type"
                            label="Type"
                            value={field.type}
                            options={[
                                {
                                    value: AmazonIdeaType.Data,
                                    label: AmazonIdeaType.Data,
                                },
                                {
                                    value: AmazonIdeaType["Option Dropdown"],
                                    label: AmazonIdeaType["Option Dropdown"],
                                },
                                {
                                    value: AmazonIdeaType.Image,
                                    label: AmazonIdeaType.Image,
                                },
                            ]}
                            onChange={handleFieldUpdate}
                        /> */}

                        <div>
                            <ComponentLabelPolaris label="Label" required />
                            <TextField
                                id="label"
                                value={field.label}
                                placeholder="Enter label"
                                onChange={handleFieldUpdate}
                                disabled={disabled}
                            />
                        </div>
                        <div>
                            <ComponentLabelPolaris
                                label={
                                    <>
                                        <span>Instructions </span>
                                        <TextStyle variation="subdued">
                                            (Optional)
                                        </TextStyle>
                                    </>
                                }
                            />
                            <TextField
                                id="instructions"
                                value={field.instructions}
                                placeholder="Enter Instructions"
                                onChange={handleFieldUpdate}
                                disabled={disabled}
                            />
                        </div>

                        {isFieldData(field.type) ? (
                            <div>
                                <ComponentLabelPolaris
                                    label={
                                        <>
                                            <span>Sample Text </span>
                                            <TextStyle variation="subdued">
                                                (Optional)
                                            </TextStyle>
                                        </>
                                    }
                                />
                                <TextField
                                    id="sampleText"
                                    value={field.sampleText}
                                    placeholder="Enter Sample text"
                                    onChange={handleFieldUpdate}
                                    disabled={disabled}
                                />
                            </div>
                        ) : null}
                        {isFieldData(field.type) ? (
                            <div>
                                <ComponentLabelPolaris
                                    label={"Character Limit"}
                                    required
                                />
                                {/* <TextField
                                    id="characterLimit"
                                    type="number"
                                    value={field.characterLimit || ""}
                                    placeholder="Enter Character limit"
                                    onChange={handleFieldUpdate}
                                /> */}
                                <Stack distribution="fillEvenly">
                                    <TextField
                                        id="min"
                                        type="number"
                                        helpText="Min"
                                        value={field.min + "" || ""}
                                        placeholder="Enter Min"
                                        onChange={handleFieldUpdate}
                                        disabled={disabled}
                                    />
                                    <TextField
                                        id="max"
                                        helpText="Max"
                                        type="number"
                                        value={field.max + "" || ""}
                                        placeholder="Enter Max"
                                        onChange={handleFieldUpdate}
                                        disabled={disabled}
                                    />
                                </Stack>
                            </div>
                        ) : null}

                        {/* <div style={{ marginTop: -3 }}>
                        <Labelled
                            label="Placeholder"
                            action={{
                                content: "Delete",
                                onAction: handleRemove,
                            }}
                        />
                        <TextField
                            id="placeholder"
                            value={field.placeholder}
                            placeholder="Enter placholder"
                            onChange={handleFieldUpdate}
                        />
                    </div> */}
                    </div>
                    {isFieldDropdown(field.type) ? (
                        // <AmazonIdeaFieldAutoComplete
                        //     index={index}
                        //     value={field.value}
                        //     onChange={(value) =>
                        //         handleFieldUpdate(
                        //             (value || []).join(","),
                        //             "value",
                        //         )
                        //     }
                        // />

                        <AmazonIdeaDropdownOption
                            optionsList={field.optionsList}
                            onChange={(value) =>
                                handleFieldUpdate(value, "optionsList")
                            }
                            disabled={disabled}
                        />
                    ) : null}
                </div>
            </Stack.Item>
        </Stack>
    );
}

function createNewField(type = AmazonIdeaType.Data) {
    return mapPropertyByType(type);
}

const PROPERTY_BY_TYPES = {
    [AmazonIdeaType.Data]: ["instructions", "sampleText", "min", "max"],
    [AmazonIdeaType["Option Dropdown"]]: ["instructions", "optionsList"],
    [AmazonIdeaType.Image]: ["instructions"],
};

function mapPropertyByType(type) {
    const match = PROPERTY_BY_TYPES[type];
    if (!match) return {};

    const res = {
        type,
        label: AmazonIdeaType[type],
    };

    const obj = {};
    for (let key of match) {
        if (key === "optionsList") {
            obj[key] = [
                { name: "Option 1", priceDifference: "" },
                { name: "Option 2", priceDifference: "" },
            ];
            continue;
        }

        if (key === "min") {
            obj[key] = "1";
            continue;
        }

        if (key === "max") {
            obj[key] = "1000";
            continue;
        }

        obj[key] = "";
    }

    return { ...res, ...obj };
}

export function calcuKpi(len) {
    return len * 0.1;
}
